import { jsx as _jsx } from "react/jsx-runtime";
import { contentCollectionFormSelector, contentCollectionShortIdSelector } from "@air/feature-content-collection/redux";
import { useShortUrlListCustomFields } from "@air/feature-custom-fields/hooks";
import { tailwindMerge } from "@air/tailwind-variants";
import { Fragment, memo, useMemo } from "react";
import { useSelector } from "react-redux";
export const ContentCollectionCustomFieldsList = /*#__PURE__*/ memo((param)=>{
    let { className, renderCustomField } = param;
    const form = useSelector(contentCollectionFormSelector);
    const shortId = useSelector(contentCollectionShortIdSelector);
    const { data, isLoading } = useShortUrlListCustomFields({
        shortId: shortId
    });
    const customFields = useMemo(()=>{
        if (!data) return [];
        return data.data.filter((customField)=>form === null || form === void 0 ? void 0 : form.fields.find((field)=>field.customFieldId === customField.id));
    }, [
        data,
        form === null || form === void 0 ? void 0 : form.fields
    ]);
    if (isLoading) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex flex-col gap-2", className),
        children: customFields.map((customField)=>{
            return /*#__PURE__*/ _jsx(Fragment, {
                children: renderCustomField({
                    customField
                })
            }, customField.id);
        })
    });
});
ContentCollectionCustomFieldsList.displayName = "ContentCollectionCustomFieldsList";
